import axios from 'axios';

export default class ShopifyProductProvider {
  static getProduct(handle) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/products/${handle}.js`)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  static getRecommendedProduct(productId, limit) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/recommendations/products.json?product_id=${productId}&limit=${limit}`
        )
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}
